var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2696",
    "data-name": "Group 2696",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.245,
    height: 18.094,
    viewBox: "0 0 27.245 18.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40754",
    "data-name": "Path 40754",
    d: "M2.773,67.414h0a.639.639,0,0,0,.5,1.173L12.2,65.616l-1.67,2.728a.517.517,0,0,0,.68.729l1.752-.91a.515.515,0,0,0,.135-.1l5.189-5.42,6.4-3.342c2.425-1.307,2.144-2.313,2-2.589a1.368,1.368,0,0,0-.915-.655,5.442,5.442,0,0,0-2.32.038,3.006,3.006,0,0,1-.713.05c-.686-.019-1.151.027-3.459,1.227L6.655,63.932l-4.9-2.541a.639.639,0,0,0-.589,0l-.825.429a.639.639,0,0,0-.2.967l3.4,4.233Z",
    transform: "translate(0 -55.948)",
    fill: "#5f5f5f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40755",
    "data-name": "Path 40755",
    d: "M37.467,282.5H13.561c-.672,0-1.217.333-1.217.743s.545.743,1.217.743H37.467c.672,0,1.217-.333,1.217-.743S38.14,282.5,37.467,282.5Z",
    transform: "translate(-11.439 -265.893)",
    fill: "#5f5f5f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneUp);
export default __webpack_public_path__ + "static/media/plane-up.438193bf.svg";
export { ForwardRef as ReactComponent };